import {GameSpeedSettings} from '@colonist/game-base-types'
import {GameTimerOption} from '@colonist/types'

export const GAME_TIMER_OPTIONS: {[key in GameSpeedSettings]: GameTimerOption} = {
    [GameSpeedSettings.Base30s]: {key: GameSpeedSettings.Base30s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Base30s'},
    [GameSpeedSettings.Base60s]: {key: GameSpeedSettings.Base60s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Base60s'},
    [GameSpeedSettings.Base120s]: {key: GameSpeedSettings.Base120s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Base120s', isDefault: true},
    [GameSpeedSettings.Base240s]: {key: GameSpeedSettings.Base240s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Base240s'},
    [GameSpeedSettings.Base12000s]: {key: GameSpeedSettings.Base12000s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Base12000s'},
    [GameSpeedSettings.Rush5s]: {key: GameSpeedSettings.Rush5s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Rush5s'},
    [GameSpeedSettings.Rush8s]: {key: GameSpeedSettings.Rush8s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Rush8s'},
    [GameSpeedSettings.Rush10s]: {key: GameSpeedSettings.Rush10s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Rush10s', isDefault: true},
    [GameSpeedSettings.Rush15s]: {key: GameSpeedSettings.Rush15s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Rush15s'},
    [GameSpeedSettings.Rush20s]: {key: GameSpeedSettings.Rush20s, labelTranslationKey: 'strings:colonistCommon.SpeedSettings.Rush20s'},
}

export const BASE_GAME_SPEED_SETTINGS: GameSpeedSettings[] = [
    GameSpeedSettings.Base30s,
    GameSpeedSettings.Base60s,
    GameSpeedSettings.Base120s,
    GameSpeedSettings.Base240s,
    GameSpeedSettings.Base12000s,
]

export const RUSH_GAME_SPEED_SETTINGS: GameSpeedSettings[] = [
    GameSpeedSettings.Rush5s,
    GameSpeedSettings.Rush8s,
    GameSpeedSettings.Rush10s,
    GameSpeedSettings.Rush15s,
    GameSpeedSettings.Rush20s,
]
